/**
 * Typed API client for platform notifications — Epic 218.
 *
 * A per-user in-app notification inbox plus an admin emitter. Distinct from the
 * events-driven /notifications bell; this is the directly-addressable channel
 * (e.g. workflow steps, admin broadcasts). Mirrors internal/notifications.
 */

import { apiClient } from '@/lib/apiClient';

export interface PlatformNotification {
  id: string;
  notifType: string;
  title: string;
  body: string | null;
  metadata: unknown;
  createdAt: string;
}

/** The caller's own unread notifications. */
export async function listMyNotifications(): Promise<PlatformNotification[]> {
  const { data } = await apiClient.get<PlatformNotification[]>('/platform-notifications');
  return data;
}

export async function markNotificationRead(id: string): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>(`/platform-notifications/${id}/read`, {});
  return data;
}

export interface SendNotificationRequest {
  userId: string;
  type?: string;
  title: string;
  body?: string;
}

/** Admin-only: emit a notification to a tenant user. */
export async function sendNotification(req: SendNotificationRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/platform-notifications/test', req);
  return data;
}
